import { useState, useEffect } from 'react'
import { request } from '@/lib/request'

export function useList<T = any>(model: string): [T[], () => Promise<void>] {
  const [list, setList] = useState<T[]>([])

  const getList = async () => {
    try {
      const resp = await request(`/system/api/query/${model}`, {
        page_size: 100,
        page_num: 1,
        query_filter: {},
      })
      if (resp && resp.code === 0) {
        setList(
          resp.data.list.map((val: any) => {
            val.key = val.id
            return val
          })
        )
      }
    } catch (error) {
      console.error('Failed to fetch list:', error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  return [list, getList]
}
